var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"group-footer"}},[_c('p',{staticClass:"font-4"},[_vm._v("Powered by PHOENIX POS")])])}]

export { render, staticRenderFns }